import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiCargoIdsGet } from '@/entities/cargo-id/modules/api/cargoIds';

// Returns the user's single Cargo ID object (or null). Per backend refactor:
// 1 Cargo ID per account.
export const useCargoIds = (enabled = true) =>
  useFetch({
    api: apiCargoIdsGet,
    keywords: queryKeys.cargoIds.all,
    enabled,
    staleTime: 60_000,
  });
